import { rotateCanvas } from "canvas-utils";

// Current PDF.js is ESM-only and uses syntax which Webpack 4 cannot parse.
// Leave the import for the browser and configure its matching module worker.
const pdfjsPromise = import(
  /* webpackIgnore: true */ "/node_modules/pdfjs-dist/legacy/build/pdf.mjs?v=4.2.67"
).then(function (pdfjs) {
  pdfjs.GlobalWorkerOptions.workerSrc =
    "/node_modules/pdfjs-dist/legacy/build/pdf.worker.mjs?v=4.2.67";
  return pdfjs;
});

//1169 x 827  = A4 @ 100dpi
//2339 x 1653 = A4 @ 200dpi
//3508 x 2480 = A4 @ 300dpi
export const pageToCanvas = function (
  page,
  maxWidth = 1653,
  maxHeight = 2339,
  forcePortrait = true,
) {
  // maxWidth refers to shortest side (might be portrait)
  // maxHeight refers to longest side (might be portrait)
  if (maxWidth > maxHeight) {
    //swap so width is allways shortest
    [maxWidth, maxHeight] = [maxHeight, maxWidth];
  }

  var promise = new Promise(function (resolve, reject) {
    var canvas = document.createElement("canvas");
    var origViewport = page.getViewport({ scale: 1 });
    var origWidth = origViewport.width;
    var origHeight = origViewport.height;
    let isLandscape = origWidth > origHeight;
    if (isLandscape) {
      //if landscape, swap max W&H
      [maxWidth, maxHeight] = [maxHeight, maxWidth];
    }
    //from this point maxWidth refers to horizontal dimension (not necessarily shortest)

    // scale to fit a max dimensions (fill width or height)
    var scale = maxWidth / origWidth;
    if (origWidth / origHeight < maxWidth / maxHeight) {
      scale = maxHeight / origHeight;
    }

    var viewport = page.getViewport({ scale });
    canvas.height = viewport.height;
    canvas.width = viewport.width;
    var context = canvas.getContext("2d");
    var renderContext = {
      canvasContext: context,
      viewport: viewport,
    };
    page
      .render(renderContext)
      .promise.then(function () {
        if (isLandscape) {
          return rotateCanvas(canvas);
        } else {
          return canvas;
        }
      })
      .then(function (canvas) {
        resolve(canvas);
        //TODO reject(Error("It broke"));
      });
  });
  return promise;
};

// returns base64 string as promise
export const pageToImageData = function (
  page,
  maxWidth = 1653,
  maxHeight = 2339,
) {
  return pageToCanvas(page, maxWidth, maxHeight).then(function (canvas) {
    return canvas.toDataURL("image/jpeg");
  });
};

//takes a url and returns a pdfjs object (as promise)
export const urlToPdf = function (url) {
  return pdfjsPromise.then(function (pdfjs) {
    return pdfjs.getDocument({
      url,
      isEvalSupported: false,
      enableScripting: false,
    }).promise;
  });
};

//converts file (from fileinput) to pdfjs object (as promise)
export const fileToPdf = function (file) {
  var fileReader = new FileReader();
  var promise = new Promise(function (resolve, reject) {
    fileReader.onload = function () {
      var typedarray = new Uint8Array(this.result);
      resolve(
        pdfjsPromise.then(function (pdfjs) {
          return pdfjs.getDocument({
            data: typedarray,
            isEvalSupported: false,
            enableScripting: false,
          }).promise;
        }),
      );
    };
    fileReader.onerror = function (e) {
      reject(e);
    };
  });
  fileReader.readAsArrayBuffer(file);
  return promise;
};

//returns an array of pages from a pdf as a promise
export const pdfToPages = function (pdf) {
  let promises = [];
  for (let i = 1; i <= pdf.numPages; i++) {
    promises.push(pdf.getPage(i));
  }
  return Promise.all(promises);
};

// returns array of base64 strings as promise
export const pdfToImageDataArray = function (
  pdf,
  maxWidth = 1653,
  maxHeight = 2339,
) {
  return pdfToPages(pdf).then(function (pages) {
    let promises = pages.map((page) =>
      pageToImageData(page, maxWidth, maxHeight),
    );
    return Promise.all(promises);
  });
};

export const fileToImageDataArray = function (
  file,
  maxWidth = 1653,
  maxHeight = 2339,
) {
  return fileToPdf(file).then(function (pdf) {
    return pdfToImageDataArray(pdf, maxWidth, maxHeight);
  });
};

export const urlToImageDataArray = function (
  url,
  maxWidth = 1653,
  maxHeight = 2339,
) {
  return urlToPdf(url).then(function (pdf) {
    return pdfToImageDataArray(pdf, maxWidth, maxHeight);
  });
};
